import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Outcome } from '../models/outcomes/Outcome'
import { ProjectOutcomeRelation } from '../models/outcomes/ProjectOutcomeRelation'
import { NgForm } from '@angular/forms';

import { API_SETTINGS } from './API_SETTINGS';
import { OutcomeGroupOutcomeRelation } from '../models/outcomes/OutcomeGroupOutcomeRelation';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'ProjectOutcomeRelation';

@Injectable({
    providedIn: 'root'
})
export class ApiProjectOutcomeRelationService {

    constructor(private http: HttpClient) { }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    getProjectOutcomeRelationByProjectId(id: number): Observable<ProjectOutcomeRelation[]> {
        const url = `${apiUrl}/GetProjectOutcomeRelationByProjectId/${id}`;
        return this.http.get<ProjectOutcomeRelation[]>(url).pipe();
    }

    addProjectOutcomeRelation(projectOutcomeRelation: ProjectOutcomeRelation): Observable<ProjectOutcomeRelation> {
        const url = apiUrl + '/PostProjectOutcomeRelationRelation'
        return this.http.post<ProjectOutcomeRelation>(url, projectOutcomeRelation, httpOptions).pipe();
    }

    AddProjectOutcomeRelationArray(projectOutcomeRelations: ProjectOutcomeRelation[]): Observable<ProjectOutcomeRelation[]> {
        const url = apiUrl + '/PostProjectOutcomeRelationArray'
        return this.http.post<ProjectOutcomeRelation[]>(url, projectOutcomeRelations, httpOptions).pipe();
    }

    deleteProjectOutcomeRelation(outcomeId, projectId) {
        const url = apiUrl + '/RemoveProjectOutcomeRelationByOutcomeIdAndProjectId';
        let toRemove = {} as ProjectOutcomeRelation;
        toRemove.outcomeId = outcomeId;
        toRemove.projectId = projectId;
        toRemove.projectOutcomeRelationId = 0;
        return this.http.post<ProjectOutcomeRelation>(url, toRemove, httpOptions).pipe(
            catchError(this.handleError<ProjectOutcomeRelation>('RemoveProjectOutcomeRelationByOutcomeIdAndProjectId'))
        );
    }
}